import * as React from 'react';

const ItemList = ({ data }) => {
  switch (data.layout) {
    case 'List':
      return (
        <div
          className="flex flex-col md:flex-row justify-between items-center md:items-start flex-wrap item-list container"
          style={{
            backgroundColor: data.background_color ? data.background_color : 'transparent',
          }}
        >
          {data.items.map((item) => {
            return (
              <div
                key={item.image?.title ? item.image.title : item.title}
                className="flex flex-col items-center item-item"
              >
                {item.image && (
                  <div className="image-wrapper w-full">
                    <img
                      src={item.image.url}
                      className="w-full h-full object-contain"
                      alt={item.image?.title ? item.image.title : item.title}
                    />
                  </div>
                )}
                {item.title && <span className="item-title">{item.title}</span>}
              </div>
            );
          })}
        </div>
      );
    default:
      return null;
  }
};

export default ItemList;
